module.exports = __webpack_public_path__ + "assets/icons/ic_sensor_boost_mode.svg";